import type { SearchAutocompleteResponse } from '@psw/shared';
import { Product } from '../Models/Product';
import { FetchService } from '../services/fetch.service';
import { type PswQueryOptions, usePswQuery } from './queries';

// ------------------------------------------------------------
// Search autocomplete
// ------------------------------------------------------------

type AutocompleteResponseModel = Omit<SearchAutocompleteResponse, 'products'> & {
  products: SearchAutocompleteResponse['products'] & { results: Product[] };
};

const transformAutocompleteResponseToProduct = (data: SearchAutocompleteResponse) => ({
  ...data,
  products: {
    ...data.products,
    results: data.products.results.map(d => new Product(d)),
  },
});

export function useAutocomplete(
  search: string,
  options?: PswQueryOptions<SearchAutocompleteResponse, AutocompleteResponseModel>,
) {
  return usePswQuery({
    ...options,
    queryKey: ['autocomplete', search],
    enabled: options && 'enabled' in options ? options.enabled : !!search,
    queryFn: () => FetchService.post<SearchAutocompleteResponse>('/search/autocomplete', { search }),
    select: transformAutocompleteResponseToProduct,
  });
}
